module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.complete),
      expression: "!complete"
    }]
  }, [_c('div', [_c('div', {
    staticClass: "c-gray m-b-20"
  }, [_c('div', {
    staticClass: "fr m-r-20 pointer",
    on: {
      "click": function($event) {
        _vm.openHistroy()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("  流程历史\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "fr m-r-40 pointer pos-rel",
    on: {
      "mouseover": function($event) {
        _vm.openLog()
      },
      "mouseout": function($event) {
        _vm.closeLog()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("  流程状态\n        "), _c('flow-log', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLog),
      expression: "showLog"
    }],
    attrs: {
      "caseId": _vm.caseId
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('commonFormRender', {
    ref: "form",
    attrs: {
      "form": _vm.form,
      "formField": _vm.formField,
      "modelId": _vm.modelId,
      "isReadonly": _vm.isReadonly,
      "complete": _vm.complete
    }
  }, [_c('flow-histroy', {
    attrs: {
      "modalShow": _vm.modalShow,
      "caseId": _vm.caseId
    },
    on: {
      "closeHistroy": _vm.closeHistroy
    }
  }), _vm._v(" "), (_vm.examineList && _vm.examineList.length > 0) ? _c('el-table', {
    staticClass: "m-t-10",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.examineList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "审批时间"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("parseTime")(scope.row.create_time)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "node_name",
      "label": "审批节点"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "审批人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "审批意见"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.examine_status == 10) ? _c('span', [_vm._v(_vm._s(scope.row.content))]) : _c('span', {
          staticStyle: {
            "color": "#ff4949"
          }
        }, [_vm._v(_vm._s(scope.row.content))]), _vm._v(" ")]
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "h-60  pos-rel top-title"
  }, [_c('div', {
    staticClass: "flowDetail-btns"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saveBtnShow),
      expression: "saveBtnShow"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v("  保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.endBtnShow),
      expression: "endBtnShow"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.endFlow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v("  结束流程")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examineShow),
      expression: "examineShow"
    }],
    attrs: {
      "type": "warning",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.addDialog(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v("  回退")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitShow && _vm.caseNode.type == 30),
      expression: "submitShow && caseNode.type ==30"
    }],
    attrs: {
      "type": "success",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.addDialog(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("  提交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.submitShow && _vm.caseNode.type != 30),
      expression: "submitShow && caseNode.type !=30"
    }],
    attrs: {
      "type": "success",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("  提交")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canRetract),
      expression: "canRetract"
    }],
    attrs: {
      "type": "danger",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.retractFlow
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v("  撤回")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stopShow),
      expression: "stopShow"
    }],
    attrs: {
      "type": "danger",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.stopFlow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("  终止")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])]), _vm._v(" "), _vm._v(" "), (_vm.currentData.currentType !== _vm.UESR_CONSTANT) ? _c('flow-process-dialog', {
    ref: "flowProcessControl",
    attrs: {
      "currentData": _vm.currentData
    },
    on: {
      "handleDialogResult": _vm.handleDialogResult
    }
  }) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    ref: "examinationDialog",
    attrs: {
      "title": _vm.examinationTitle
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "填写内容"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.examine_opinion),
      expression: "examine_opinion"
    }],
    attrs: {
      "type": "textarea",
      "placeholder": _vm.填写审批内容
    },
    domProps: {
      "value": (_vm.examine_opinion)
    },
    on: {
      "input": function($event) {
        _vm.examine_opinion = $event
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeExaminationDialog
    }
  }, [_vm._v("返 回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add(_vm.isPass)
      }
    }
  }, [_vm._v("提 交")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31b34ba6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/detail.vue
// module id = 1813
// module chunks = 2